import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { selectSessionFilterMeetingTemplateIds, setSessionFilterMeetingTemplateIds } from '../../store/sessionFilter/sessionFilter'
import { useGetMeetingTemplatesQuery } from '../../store/ai/meetingTemplate'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'

import { MultiSelectDropdown } from '../MultiSelectDropdown/MultiSelectDropdown'
import { SelectOption } from '../SelectDropdown/SelectDropdown'

import { SessionFilterViewProps } from './model'

import './SessionMeetingTemplateFilter.scss'

export const SessionMeetingTemplateFilter: React.FC<SessionFilterViewProps> = ({ disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const sessionFilterMeetingTemplateIds = useAppSelector(selectSessionFilterMeetingTemplateIds)

  const { data: meetingTemplates } = useGetMeetingTemplatesQuery(
    { accountId, pageRequest: { page: 0, size: 500 }, includeInactive: false },
    { refetchOnMountOrArgChange: true },
  )

  const [searchParams] = useSearchParams()

  const meetingTemplateOptions = useMemo<SelectOption[]>(() => {
    if (!meetingTemplates?.data) {
      return []
    }

    return meetingTemplates.data.map((template) => ({ id: template.id, label: template.name })).sort((left, right) => left.label.localeCompare(right.label))
  }, [meetingTemplates])

  const handleMeetingTemplateIdsChanged = (ids: string[]) => {
    if (ids.length < 1) {
      searchParams.delete('meetingTemplates')
    } else {
      searchParams.set('meetingTemplates', JSON.stringify(ids))
    }

    searchParams.delete('filterId')

    if (onFilterChanged) {
      onFilterChanged(searchParams)
    }

    dispatch(setSessionFilterMeetingTemplateIds(ids))
  }

  return (
    <div>
      <div className='mb-1'>Filter by meeting type {sessionFilterMeetingTemplateIds.length ? `(${sessionFilterMeetingTemplateIds.length})` : null}</div>

      <MultiSelectDropdown
        name='meetingTemplateIds'
        options={meetingTemplateOptions}
        initialSelectedOptions={sessionFilterMeetingTemplateIds}
        onSelectedChanged={handleMeetingTemplateIdsChanged}
        disabled={disabled}
        className='session-meeting-template-filter-dropdown'
      />
    </div>
  )
}
